var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { LayerProvider } from './layerProvider';
import { useLayer } from './useLayer';
const Root = styled.div({ position: 'relative' });
const LayerChildren = forwardRef((props, ref) => {
    const { children, style = {} } = props, restProps = __rest(props, ["children", "style"]);
    const { zIndex } = useLayer();
    return (React.createElement(Root, Object.assign({}, restProps, { ref: ref, style: Object.assign(Object.assign({}, style), { zIndex }) }), children));
});
LayerChildren.displayName = 'LayerChildren';
export const Layer = forwardRef((props, ref) => {
    const { children, zOffset = 1 } = props, restProps = __rest(props, ["children", "zOffset"]);
    return (React.createElement(LayerProvider, { zOffset: zOffset },
        React.createElement(LayerChildren, Object.assign({}, restProps, { ref: ref }), children)));
});
Layer.displayName = 'Layer';
//# sourceMappingURL=layer.js.map